import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook para detectar si la aplicación se está ejecutando dentro de un iframe.
 * Maneja correctamente el Server-Side Rendering (SSR) evitando hydration mismatches.
 * 
 * @returns {boolean} true si está en un iframe o si tiene el query param ?iframe=true.
 */
export const useIframeDetection = () => {
  const detectIframe = search => {
    if (typeof window === 'undefined') {
      return false;
    }

    // 1) URL flag (works for local/dev and explicit iframe routing)
    const urlParams = new URLSearchParams(search ?? window.location.search);
    if (urlParams.has('iframe')) {
      return true;
    }

    // 2) Native window checks
    try {
      if (window.self !== window.top) {
        return true;
      }
    } catch (e) {
      // Cross-origin access to window.top throws only when embedded
      return true;
    }

    // 3) Extra fallback for embedded contexts
    return !!window.frameElement;
  };

  // Initialize from runtime detection to avoid first-render fallback to regular topbar
  const [isIframe, setIsIframe] = useState(() => detectIframe());
  const location = useLocation();

  useEffect(() => {
    setIsIframe(detectIframe(location?.search));
  }, [location?.search]);

  return isIframe;
};

export default useIframeDetection;
